import * as Rest from "../../Generated/RestClient";
import getBotResourceId from "./botResourceId";
import {clientAppSettings} from "../../Models/ClientAppSettings";

export enum BladeType {
    _none,
    continuousIntegration,
    webConfig,
    appSettings,
    functionEditor,
    createAbs
}

function getEnvQuery() : string {
  const env = clientAppSettings.environment.toLowerCase();
  switch (env) {
    case 'scratch':
    case 'ppe':
      return `?appsvc.bots.env=${env}`;
    default:
      return ''
  }
}

export function getAzurePortalBladeUrl(bot:Rest.BotService, 
  domainName: string,
  bladType: BladeType) : string {
  const portalHostName = domainName === 'microsoft.onmicrosoft.com' ? 'ms.portal.azure.com' : 'portal.azure.com';
  const azureDomainRoot = `https://${portalHostName}/${domainName ? "signin/index/@" + domainName : ""}/${getEnvQuery()}`;
  const siteBladeUrl = `${azureDomainRoot}#resource${getBotResourceId(bot)}`;
  switch (bladType) {
    case BladeType.continuousIntegration:
      return `${siteBladeUrl}/DeploymentSource`;
    case BladeType.webConfig:
      return `${siteBladeUrl}/application`;
    case BladeType.createAbs:
      return `https://portal.azure.com/${getEnvQuery()}#create/Microsoft.BotApp`;
    case BladeType.appSettings:
    default:
      return siteBladeUrl;
  }
}


// WEBPACK FOOTER //
// ./Client/v4/Services/azurePortalLinks.ts